import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import MyDashboard from './views/MyDashboard.vue';
import MembershipHome from './views/MembershipHome.vue';

import EmailVerified from './views/EmailVerified.vue';
// import Create from './views/Create.vue';

import Login from './views/user/Login.vue';
import Auth from './views/user/Auth.vue';
import DeletedPoll from './views/DeletedPoll.vue';
import MarketingEmail from './views/MarketingEmail.vue';
import TestView from './views/TestView.vue';
import TestPoll from './views/TestPoll.vue';

import RequestPasswordReset from '@/components/Login/RequestPasswordReset.vue';
import PasswordReset from '@/components/Login/PasswordReset.vue';



import ResetRequest from './views/user/ResetRequest.vue';
import ResetLink from './views/user/ResetLink.vue';

import PrintInvoiceDetails from './views/PrintInvoiceDetails.vue'

import store from '@/store/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    /*  depricated
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    */
    {
      path: '/emailverify/:id/:hash',
      name: 'verification',
      component: EmailVerified,
    },

    {
      path: '/auth',
      component: Auth,
      children: [
        { path: '/auth/requestreset', component: RequestPasswordReset },
        {
          path: '/auth/passwordreset/:token/:email',
          component: PasswordReset,
          props: true,
        },
      ],
    },
    {
      path: '/reset',
      name: 'reset',
      component: ResetRequest,
    },

    {
      path: '/reset',
      name: 'reset',
      component: ResetRequest,
    },

    {
      path: '/resetlink',
      name: 'resetlink',
      component: ResetLink,
    },

    // {
    //   path: '/resetpassword/:selector?',
    //   name: 'resetlink',
    //   component: ResetPassword,
    //   props: true,
    // },

    {
      path: '/login/:mode?',
      name: 'login',
      component: Login,
      params: { loginRoot: '/dashboard' },
      props: true,
    },

    {
      path: '/passwordchanged',
      name: 'passwordchanged',
      component: Login,
      params: { loginRoot: '/dashboard' },
      props: true,
    },

    {
      path: '/signin/:id?/:hash?',
      name: 'signin',
      component: Login,
      params: { loginRoot: '/dashboard' },
      props: true,
    },

    {
      path: '/deleted',
      name: 'deleted',
      component: DeletedPoll,
    },

    {
      path: '/marketing-email',
      name: 'marketingEmail',
      component: MarketingEmail,
    },

    {
      path: '/test-view',
      name: 'testView',
      component: TestView,
    },

    {
      path: '/perf-test/:id/:key?',
      name: 'perf-test',
      component: TestPoll,
    },

    {
      path: '/',
      beforeEnter(to, from, next) {
        const userId = localStorage.getItem('userId');
        const isAuth = userId != null;
        console.error('check for root redirect:', isAuth, userId);
        if (isAuth) {
          next('/dashboard');
        } else {
          console.log('route My Polls - isAuthenticated:true ');
          //window.location.replace('http://kulibri.com');
          next('/dashboard');
        }
      },
    },

    {
      path: '/homeold',
      name: 'home',
      component: Home,
      meta: { requiresAuth: false },
      // beforeEnter(to, from, next) {
      //   if (localStorage.getItem('userId') != null) {
      //     console.log('route My Polls - isAuthenticated:true ');
      //     next();
      //   } else {
      //     console.log('route My Polls - isAuthenticated:false ');
      //     next('/login');
      //   }
      // },
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: MyDashboard,
      beforeEnter(to, from, next) {
        if (localStorage.getItem('userId') != null) {
          console.log('route My Polls - isAuthenticated:true ');
          next();
        } else {
          console.log('route My Polls - isAuthenticated:fale ');
          next('/signin');
        }
      },
    },

    {
      path: '/membership',
      name: 'membership',
      component: MembershipHome,
      beforeEnter(to, from, next) {
        if (localStorage.getItem('userId') != null) {
          console.log('route My Polls - isAuthenticated:true ');
          next();
        } else {
          console.log('route My Polls - isAuthenticated:fale ');
          next('/signin');
        }
      },
    },

    {
      path: '/membership/print-invoice-details/:id?/',
      name: 'printInvoive',
      component: PrintInvoiceDetails,
      beforeEnter(to, from, next) {
        if (localStorage.getItem('userId') != null) {
          console.log('route My Polls - isAuthenticated:true ');
          next();
        } else {
          console.log('route My Polls - isAuthenticated:fale ');
          next('/signin');
        }
      },
    },

    {
      path: '/pr/:id/:key?',
      name: 'pr',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Poll.vue'),
    },

    {
      path: '/agb',
      name: 'agb',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/agb.vue'),
    },
    {
      path: '/dataprivacy',
      name: 'dataprivacy',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/DataPrivacy.vue'),
    },
  ],
});

export default router;

function isAuthenticated() {
  return store.getters.isAuthenticated;
}

router.beforeEach((to, from, next) => {
  let requiresAuth = to.meta.requiresAuth;
  console.log({ requiresAuth });
  if (requiresAuth && !isAuthenticated()) {
    console.log('login');
    next('login');
  } else {
    console.log('next');
    next();
  }
});

